import React from 'react'

const BallsLoader = () => (
  <div className="ball-loader">
    {
      [1,2,3].map(index => (
        <div className={ `ball ball${index}` } key={ index } />
      ))
    }
  </div>
)

export default BallsLoader;